import { ApiHelper } from './apiHelper';

export class PolicyHolderApi {
    getPolicyHolderDetails(
        referenceNumber,
        token,
        successCallback = null,
        failureCallback = null
    ) {
        var query = encodeURI(`?referenceNumber=${referenceNumber}`);
        var dataUrl = '/api/policyHolder/getPolicyHolderDetails' + query;
        new ApiHelper().getDataSecure(
            dataUrl,
            token,
            successCallback,
            failureCallback
        );
    }
}
